"use strict";

exports.__esModule = true;
exports.SPACINGS = exports.JUSTIFY = exports.DIRECTIONS = exports.ALIGNS = void 0;
let DIRECTIONS = exports.DIRECTIONS = /*#__PURE__*/function (DIRECTIONS) {
  DIRECTIONS["ROW"] = "row";
  DIRECTIONS["COLUMN"] = "column";
  DIRECTIONS["ROWREVERSE"] = "row-reverse";
  DIRECTIONS["COLUMNREVERSE"] = "column-reverse";
  return DIRECTIONS;
}({});
let ALIGNS = exports.ALIGNS = /*#__PURE__*/function (ALIGNS) {
  ALIGNS["START"] = "start";
  ALIGNS["END"] = "end";
  ALIGNS["CENTER"] = "center";
  ALIGNS["STRETCH"] = "stretch";
  ALIGNS["BASELINE"] = "baseline";
  return ALIGNS;
}({});
let JUSTIFY = exports.JUSTIFY = /*#__PURE__*/function (JUSTIFY) {
  JUSTIFY["START"] = "start";
  JUSTIFY["END"] = "end";
  JUSTIFY["CENTER"] = "center";
  JUSTIFY["BETWEEN"] = "between";
  JUSTIFY["AROUND"] = "around";
  return JUSTIFY;
}({});
let SPACINGS = exports.SPACINGS = /*#__PURE__*/function (SPACINGS) {
  SPACINGS["NONE"] = "none";
  SPACINGS["FIFTY"] = "50";
  SPACINGS["ONE_HUNDRED"] = "100";
  SPACINGS["ONE_HUNDRED_FIFTY"] = "150";
  SPACINGS["TWO_HUNDRED"] = "200";
  SPACINGS["THREE_HUNDRED"] = "300";
  SPACINGS["FOUR_HUNDRED"] = "400";
  SPACINGS["FIVE_HUNDRED"] = "500";
  SPACINGS["SIX_HUNDRED"] = "600";
  SPACINGS["EIGHT_HUNDRED"] = "800";
  SPACINGS["ONE_THOUSAND"] = "1000";
  SPACINGS["ONE_THOUSAND_TWO_HUNDRED"] = "1200";
  SPACINGS["ONE_THOUSAND_SIX_HUNDRED"] = "1600";
  return SPACINGS;
}({});